// extracted by mini-css-extract-plugin
export default {"main":"RefStatistics_main__uCB9G","content":"RefStatistics_content__0iU3j","wrapper":"RefStatistics_wrapper__6JacO"};